// extracted by mini-css-extract-plugin
export default {"skill":"style_skill__aGKQD","skillNum":"style_skillNum__SHO5a","text":"style_text__do2BW"};